import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Endpoints } from '../../apis';
import { getErrorMessage } from '@xver/utils/error';
import { INSTANCE_LIST_QUERY_KEY } from './useInstanceListQuery';

export function useToggleBackupMutate() {
    const { t } = useTranslation('notifications');
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (instanceID: number) => Endpoints.v1.Backups.toggleBackup(instanceID),
        onSuccess: (_data, instanceID) => {
            queryClient.invalidateQueries({ queryKey: INSTANCE_LIST_QUERY_KEY });
            queryClient.invalidateQueries({ queryKey: ['api.v1.instances.get', instanceID] });
            queryClient.invalidateQueries({ queryKey: ['api.v1.backups.settings', instanceID] });
            queryClient.invalidateQueries({ queryKey: ['api.v1.backups.list', instanceID] });
            notifications.show({
                title: t('backup.settingUpdatedTitle'),
                message: t('backup.settingUpdatedMessage'),
                icon: <IconCheck size={32} color={'#00ff00'} />,
            });
        },
        onError: (error: any) => {
            notifications.show({
                title: t('backup.settingUpdateFailedTitle'),
                message: getErrorMessage(error),
                icon: <IconExclamationCircle size={32} color={'#eb5757'} />,
            });
        },
    });
}
